module.exports = __webpack_public_path__ + "img/translator.919ef654.png";